import React from 'react';

export const Community = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="192"
      height="192"
      viewBox="0 0 192 192">
      <defs>
        <path id="a" d="M0 .408h159.429V11.54H0z" />
        <path
          id="c"
          d="M109.629 85.61c0-1.861-.464-3.62-1.393-5.275-.928-1.655-2.203-3.103-3.823-4.345-1.621-1.241-3.507-2.217-5.659-2.926-2.15-.71-4.464-1.064-6.94-1.064-2.446 0-4.752.355-6.918 1.064-2.166.71-4.052 1.685-5.658 2.926-1.606 1.242-2.88 2.69-3.823 4.345C74.472 81.99 74 83.749 74 85.611c0 1.537.368 3.037 1.105 4.5a26.066 26.066 0 002.52 4.056c1.15 1.478 1.304 3.31.464 5.498-.84 2.187-1.643 3.695-2.41 4.522a9.108 9.108 0 003.648-.754 69.459 69.459 0 003.602-1.684 37.034 37.034 0 014-1.707c1.43-.517 3.058-.776 4.885-.776 2.476 0 4.79-.355 6.94-1.064 2.152-.71 4.038-1.685 5.659-2.926 1.62-1.242 2.895-2.69 3.823-4.345a10.704 10.704 0 001.393-5.32zM91.814 96.297c-2.21 0-4.162.303-5.857.908a41.103 41.103 0 00-4.575 1.929c.236-1.153.273-2.32.11-3.502a6.558 6.558 0 00-1.348-3.193c-.972-1.27-1.716-2.49-2.232-3.657-.516-1.168-.773-2.224-.773-3.17 0-1.448.383-2.823 1.149-4.123.766-1.3 1.812-2.431 3.138-3.392 1.326-.96 2.888-1.722 4.686-2.283 1.798-.562 3.698-.843 5.702-.843 2.034 0 3.942.281 5.725.843 1.783.561 3.337 1.322 4.663 2.283 1.326.96 2.38 2.091 3.161 3.392.78 1.3 1.171 2.675 1.171 4.123 0 1.478-.39 2.867-1.171 4.167-.781 1.3-1.835 2.431-3.16 3.392-1.327.96-2.881 1.722-4.664 2.283-1.783.562-3.691.843-5.725.843zm6.896-12.06c-.59 0-1.09.2-1.503.599-.412.399-.619.88-.619 1.44 0 .562.207 1.035.62 1.42.412.384.913.576 1.502.576.59 0 1.09-.192 1.503-.576.413-.385.619-.858.619-1.42 0-.56-.206-1.041-.619-1.44a2.082 2.082 0 00-1.503-.599zm-6.896 0c-.59 0-1.09.2-1.503.599-.412.399-.618.88-.618 1.44 0 .562.206 1.035.618 1.42.413.384.914.576 1.503.576.59 0 1.09-.192 1.503-.576.413-.385.62-.858.62-1.42 0-.56-.207-1.041-.62-1.44a2.082 2.082 0 00-1.503-.599zm-6.896 0c-.589 0-1.09.2-1.502.599-.413.399-.62.88-.62 1.44 0 .562.207 1.035.62 1.42.412.384.913.576 1.502.576.59 0 1.09-.192 1.503-.576.413-.385.62-.858.62-1.42 0-.56-.207-1.041-.62-1.44a2.082 2.082 0 00-1.503-.599zm31.341 16.271a17.736 17.736 0 001.923-3.08c.545-1.11.818-2.225.818-3.348 0-1.98-.663-3.769-1.99-5.365-1.325-1.596-3.05-2.822-5.171-3.68v.577c0 1.921-.405 3.731-1.216 5.43-.81 1.7-1.923 3.23-3.337 4.59-1.415 1.36-3.102 2.512-5.062 3.458-1.96.945-4.074 1.596-6.343 1.95 1.238 1.005 2.69 1.803 4.354 2.394 1.665.592 3.456.887 5.371.887 2.77 0 5.003.613 6.697 1.84 1.695 1.227 3.5 1.84 5.415 1.84-.56-.62-1.157-1.751-1.79-3.392-.634-1.64-.523-3.007.331-4.1z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path fill="#D6DDE6" d="M161.834 133.102H29.594v-70.39c0-6.89 5.581-12.475 12.466-12.475h119.774v82.865z" />
        <path
          fill="#828384"
          d="M30.83 131.865h129.767V51.474H41.982c-6.149 0-11.152 5.006-11.152 11.16v69.23zm132.24 2.474H28.36V62.633C28.36 55.116 34.47 49 41.981 49H163.07v85.339z"
        />
        <path fill="#DEE0D3" d="M155.654 126.917H35.774V65.465c0-4.995 4.047-9.044 9.039-9.044h110.84v70.496z" />
        <path
          fill="#F1F2F2"
          d="M43.19 60.131a3.708 3.708 0 00-3.708 3.71v28.446l32.132-32.156H43.19zm111.228 32.156l-33.368 33.394h33.368z"
        />
        <path fill="#FFF" d="M154.418 125.681H39.482V79.212c0-10.538 8.537-19.08 19.067-19.08h95.869v65.55z" />
        <path
          fill="#DEE0D3"
          d="M166.154 141.76H25.276a8.043 8.043 0 01-8.04-8.045v-.614h156.957v.614c0 4.442-3.6 8.044-8.04 8.044"
        />
        <path
          fill="#FFF"
          d="M169.51 138.049H24.389a3.445 3.445 0 01-3.444-3.448v-.262h152.013v.262a3.447 3.447 0 01-3.446 3.448"
        />
        <g transform="translate(16 131.456)">
          <mask id="b" fill="#fff">
            <use xlinkHref="#a" />
          </mask>
          <path
            fill="#828384"
            d="M2.472 2.882v2.474a3.712 3.712 0 003.707 3.71h147.07a3.712 3.712 0 003.708-3.71V2.882H2.472zM153.25 11.54H6.18A6.188 6.188 0 010 5.356V.408h159.43v4.948c0 3.41-2.773 6.184-6.18 6.184z"
            mask="url(#b)"
          />
        </g>
        <path
          fill="#F1F2F2"
          d="M43.19 60.131a3.708 3.708 0 00-3.708 3.71v36.519L79.68 60.13H43.189zm111.228 33.38l-32.146 32.171h32.146z"
        />
        <path
          fill="#828384"
          d="M37.01 125.681h117.41V57.657H43.188c-3.406 0-6.18 2.774-6.18 6.184v61.84zm119.881 2.474H34.538V63.841c0-4.773 3.881-8.658 8.651-8.658h113.702v72.972z"
        />
        <use fill="#F48C00" xlinkHref="#c" />
      </g>
    </svg>
  );
};
